module.exports = __webpack_public_path__ + "media/images/koala-vet-logo-suffix-80363ec09c613ce46795895dc6d9dfad.svg";